import finBreakpoint from "@/js/errorhandler/finBreakpoint"
import colors from "fincraft-lib-basics/src/js/colors"

const chartHeights={
  big: {xs: 208, md: 208, lg: 275, xl: 400},
  medium: {xs: 100},
  small: {xs:40}
}

export default {
  tradingPlatforms:{
    citibank: {
      id: "citibank",
      name: "Citibank",
      url:  "https://www.citigroup.com"
    },
    infront: {
      id: "infront",
      name: "Infront",
      url:  "https://www.vwd.com/infront/"
    },
    tradegate: {
      id: "tradegate",
      name: "Tradegate",
      url:  "https://www.tradegate.de/"
    }
  },

  /**if you need to use objectFormat check https://api.highcharts.com/highstock/series.line.turboThreshold and
   * point 3 in https://www.highcharts.com/docs/chart-concepts/series#the-data-in-a-series*/
  mapTimeSeriesPoint(data, valueField = 'close', timeStampField = 'timestamp', objectFormat = false) {

    if (!data) {
      return data
    }
    if (objectFormat) {
      return data.map(point => ({
          ...point,
          x: new Date(point[timeStampField]).getTime(),
          y: point[valueField]
        }
      ))
    } else {
      return data.map(point => [new Date(point[timeStampField]).getTime(), point[valueField]])
    }
  },
  // for the chart displayed in the no-portfolio-yet component
  createPlaceholderChart(color, that) {
    return {
      title: '',
      chart: {
        type: 'area',
        height: that && that.$vuetify.breakpoint.xs ? 155 : 255,
      },
      preset: 'sparkline',
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        series: {
          lineWidth: 3,
          enableMouseTracking: false,
        },
      },
      series: [
        {
          color,
          name: name,
          data: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        }
      ]
    }
  },

  createCardSelectorSeries(name, data, color) {
    if (data) {
      const serie = {
        name: name,
        data: data,
        type: "area",
        tooltip: {
          valueDecimals: 2
        },
      }

      if (color) {
        serie.color = color
      }
      return serie
    }
    return null
  },

  createPerformanceChart(name, data, size, breakpoint, credits = true, valueSuffix,  legend = false,
                         extremes = true, sparkline, selected){
    //TODO refactor this method ann all parameter
    const color = colors["soft-green"]
    const result = this.createCardSelectorChart(name, data, size, breakpoint, credits, valueSuffix, color, legend, extremes, sparkline, selected)
    if(result.series?.length){
      result.series[0].negativeColor= colors["pale-red"]
    }

    result.tooltip = {
      pointFormat: `${name} (absolut): {point.y}<br />`
        + `Wert des Portfolios: {point.curr:.2f}€<br />`,
      changeDecimals: 2,
      valueDecimals: 2,
      valueSuffix
    }

    return result
  },

  /*
  *TODO improve this methods, maybe with presetlists
  * and just the merge conf
  * or a fin chartbuilder with nice fluent api
  * */
  createCardSelectorChart(name, data, size, breakpoint, credits = true, valueSuffix, color, legend = false,
                          extremes = true, sparkline, selected = null) {
    //TODO confi object
    //TODO better responsive rules
    const isBig = size === 'big'
    const isSmall = size === 'small'
    const height = chartHeights[size]

    const result = {
      preset: isSmall || sparkline ? 'sparkline' : null,
      chart: {
        height: finBreakpoint.valueByBreakpoint(breakpoint.name, height)
      },
      credits: {
        enabled: isBig && !!credits,
        html: credits ? this.createRealTimeCredits(credits) : '',
      },
      legend: {
        enabled: isBig && legend,
      },

      series: [],
      responsive: {
        rules: finBreakpoint.beakpoints.map(b => ({
          condition: {
            callback() {
              return breakpoint.name === b
            }
          },
          chartOptions: {
            chart: {
              height: finBreakpoint.valueByBreakpoint(b, height)
            },
          }
        })),
      }
    }

    if(!isSmall && selected){
      result.rangeSelector={
        initSelection: selected
      }
    }

    const series = this.createCardSelectorSeries(name, data, color)
    if (series) {
      result.series.push(
        series
      )
    }

    result.yAxis = extremes ? {
      showExtremes: {
        min: isBig,
        max: isBig
      }
    } : {}

    if (valueSuffix) {
      result.tooltip = {
        valueSuffix
      }
    }

    return result
  },
  createRealTimeCredits(tradingPlatform){
    if(!tradingPlatform || tradingPlatform===true){
      tradingPlatform= this.tradingPlatforms.tradegate
    }

    if(tradingPlatform === this.tradingPlatforms.infront){
      return this.createCreditLink('Historische Kurse und Realtime Kurse', tradingPlatform)
    }

    return this.createCreditLink('Historische Kurse', this.tradingPlatforms.infront)+', '+ this.createCreditLink('Realtime Kurse', tradingPlatform)
  },

  createCreditLink(title, data){
    return `<tspan class="credit-nolink">${title}: <tspan class="creditlink" onclick="window.open('${data.url}','_blank')">${data.name}</tspan>`
  }
}
